import { observer } from "mobx-react-lite";
import React from "react";
import CacheStore from "./CacheControlStore"; // Import the store
import {
  BlueButton,
  CustomLabel,
  FlexContainer,
  ModalComponent,
} from "@mindmemobile/mm-shared-global";
const UpdateNotifier = observer(() => {
  if (!CacheStore.needsUpdate) return null;

  return (
    <ModalComponent
      title="Update Available"
      titleFontSize="22px"
      bodyPadding="40px 45px"
      showFooter={true}
      wrapperWidth="650px"
      bodyBackgroundColor="#fff"
      orangeHeader={true}
      blueHeader={false}
      footerHeight="auto"
      minHeight="auto"
      showCrossButton={false}
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <BlueButton
            minWidth="120px"
            height="40px"
            onClick={() => {
              CacheStore.stopVersionCheck();
            }}
          >
            Cancel
          </BlueButton>
          <BlueButton
            minWidth="120px"
            height="40px"
            onClick={() => {
              CacheStore.needsUpdate = false; // Reset the update flag
              window.location.reload(); // Reload the page to get the latest version
            }}
          >
            Refresh
          </BlueButton>
        </FlexContainer>
      }
    >
      <CustomLabel textAlign="center" fontSize="16px">
        An update is available. Please refresh the page to get the latest
        version.
      </CustomLabel>
    </ModalComponent>
  );
});

export default UpdateNotifier;
